import { render } from "./BodyRowEmpty.vue?vue&type=template&id=c6c9ba10"
import script from "./BodyRowEmpty.vue?vue&type=script&lang=js"
export * from "./BodyRowEmpty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__